import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MASS_OS_SERVICE_TYPE_OPTIONS } from 'src/entities/file';

@Component({
  selector: 'app-mass-os-service-types',
  templateUrl: './mass-os-service-types.component.html',
  styleUrls: ['./mass-os-service-types.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MassOsServiceTypesComponent {
  @Input() serviceTypeIds: string[] = [];
  @Input() submitted = false;

  @Output() formChange = new EventEmitter<{ serviceTypeIds: string[] }>();

  readonly serviceTypes = MASS_OS_SERVICE_TYPE_OPTIONS;

  trackByService = (_index: number, service: { id: string }): string =>
    service.id;

  get allServicesSelected(): boolean {
    return this.serviceTypeIds.length === this.serviceTypes.length;
  }

  get serviceTypesError(): string | null {
    return this.submitted && !this.serviceTypeIds.length
      ? 'Servicios son requeridos'
      : null;
  }

  onToggleAll(): void {
    this.formChange.emit({
      serviceTypeIds: this.allServicesSelected
        ? []
        : this.serviceTypes.map((service) => service.id)
    });
  }

  onToggleService(id: string): void {
    const serviceTypeIds = this.serviceTypeIds.includes(id)
      ? this.serviceTypeIds.filter((value) => value !== id)
      : [...this.serviceTypeIds, id];
    this.formChange.emit({ serviceTypeIds });
  }
}
